export const keyActionTypes = {
    insertImage: 'mod+p',
    insertLink: 'mod+k',
};
